var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0-Base/icons/plus",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,13.0205769 23.1732692,13.8467308 22.1538462,13.8467308 L13.8461538,13.8467308 L13.8461538,22.1544231 C13.8461538,23.175 13.0194231,24 12,24 C10.9805769,24 10.1538462,23.175 10.1538462,22.1544231 L10.1538462,13.8467308 L1.84615385,13.8467308 C0.826730769,13.8467308 0,13.0205769 0,12 C0,10.9794231 0.826730769,10.1544231 1.84615385,10.1544231 L10.1538462,10.1544231 L10.1538462,1.84673077 C10.1538462,0.826153846 10.9805769,0 12,0 C13.0194231,0 13.8461538,0.826153846 13.8461538,1.84673077 L13.8461538,10.1544231 L22.1538462,10.1544231 C23.175,10.1538462 24,10.9788462 24,12 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.c860877354c3728f3863edb6ecf90108.svg";
export { ForwardRef as ReactComponent };